(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["imws-form-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ImwsFormDefined) return;
  window.__ImwsFormDefined = true;

  var KLAVIYO_SOURCE = 'WaterIqAnalyze';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  var DETECTED_CONTAMINANTS = [
    'Haloacetic acids (HAA5)',
    'Total trihalomethanes (TTHMs)',
    'Chromium (hexavalent)',
    'Nitrate',
    'Arsenic',
    'Radium, combined (-226 & -228)',
    'Uranium',
    'Lead',
    'Copper',
    'Fluoride',
    'Chlorate',
    'Barium',
    'Manganese',
    'Strontium',
    'Vanadium',
    'Molybdenum'
  ];

  var NOT_DETECTED = [
    '1,2,3-Trichloropropane',
    '1,4-Dioxane',
    'Benzene',
    'Carbon tetrachloride',
    'PFOA',
    'PFOS',
    'Atrazine',
    'Glyphosate',
    'Simazine',
    'Tetrachloroethylene',
    'Trichloroethylene',
    'Vinyl chloride',
    'MTBE',
    'Perchlorate',
    'Bromate',
    'Chlorite',
    'Cyanide',
    'Mercury (inorganic)',
    'Antimony',
    'Beryllium',
    'Cadmium',
    'Selenium',
    'Thallium',
    'Asbestos',
    '2,4-D',
    'Alachlor',
    'Chlordane',
    'Dalapon',
    'Dibromochloropropane',
    'Dinoseb',
    'Dioxin (2,3,7,8-TCDD)',
    'Endrin',
    'Ethylene dibromide',
    'Heptachlor',
    'Lindane',
    'Methoxychlor',
    'PCBs',
    'Pentachlorophenol',
    'Toxaphene'
  ];

  var SHARE_FILES = 'https://cdn.shopify.com/s/files/1/0640/4115/6719/files/'; // AquaTru Files PNGs (facebook, x-twitter, reddit, instagram, whatsapp, envelope)
  var SHARE_ICONS = {
    facebook: SHARE_FILES + 'facebook.png?v=1777308229',
    x: SHARE_FILES + 'x-twitter.png?v=1777308229',
    reddit: SHARE_FILES + 'reddit.png?v=1777308229',
    instagram: SHARE_FILES + 'instagram.png?v=1777308229',
    whatsapp: SHARE_FILES + 'whatsapp.png?v=1777308228',
    email: SHARE_FILES + 'envelope.png?v=1777308229'
  };

  var DOWNLOAD_ICON =
    '<svg class="imws-legal__download-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 4v10"/><path d="M8 10l4 4 4-4"/><path d="M5 19h14"/></svg>';

  function attr(el, key) {
    return (el && el.getAttribute('data-' + key)) || '';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function contrastingInk(backgroundColor) {
    var match = String(backgroundColor || '').match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
    if (!match) return '#ffffff';
    var r = Number(match[1]) / 255;
    var g = Number(match[2]) / 255;
    var b = Number(match[3]) / 255;
    function linearize(channel) {
      return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }
    var luminance = 0.2126 * linearize(r) + 0.7152 * linearize(g) + 0.0722 * linearize(b);
    return luminance > 0.45 ? '#1a2e35' : '#ffffff';
  }

  function titleCase(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\b\w/g, function (ch) {
        return ch.toUpperCase();
      });
  }

  function toPpb(raw) {
    if (raw === -1 || raw === '-1' || raw == null || raw === '') return null;
    var n = Number(raw);
    if (!Number.isFinite(n)) return null;
    return Number((n * 1000).toFixed(3));
  }

  function formatPpb(value) {
    if (value == null) return 'None';
    return String(value) + ' ppb';
  }

  function ratioFor(item) {
    var value = Number(item && item.ContaminantValue);
    var hg = Number(item && item.ContaminantHGValue);
    if (!Number.isFinite(value) || !Number.isFinite(hg) || hg <= 0) return 0;
    return Math.floor(value / hg);
  }

  function processContaminants(list) {
    var items = Array.isArray(list) ? list.slice() : [];
    return items
      .filter(function (item) {
        return ratioFor(item) > 0;
      })
      .sort(function (a, b) {
        return ratioFor(b) - ratioFor(a);
      })
      .map(function (raw, index) {
        var utility = toPpb(raw.ContaminantValue);
        var guideline = toPpb(raw.ContaminantHGValue);
        var legal = toPpb(raw.ContaminantMCLValue);
        var stateAvg = toPpb(raw.ContaminantStateAvg);
        var nationalAvg = toPpb(raw.ContaminantNationalAvg);
        var values = [utility, guideline, legal, stateAvg, nationalAvg].filter(function (v) {
          return v != null && v > 0;
        });
        var maxBarValue = values.length ? Math.max.apply(null, values) : 1;
        return {
          id: raw.ContaminantCode || index,
          contaminant: [raw],
          ratio: ratioFor(raw),
          utility: utility,
          guideline: guideline,
          legal: legal,
          stateAvg: stateAvg,
          nationalAvg: nationalAvg,
          timeline: raw.ContaminantTimeFrame || '',
          maxBarValue: maxBarValue,
          name: raw.ContaminantName || 'Contaminant',
          effect: raw.ContaminantEffect || '',
          description: raw.ContaminantDescription || ''
        };
      });
  }

  function polar(cx, cy, r, angle) {
    var rad = ((angle - 90) * Math.PI) / 180;
    return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
  }

  function arcPath(cx, cy, r, start, end) {
    var sweep = end - start;
    if (sweep <= 0) return '';
    if (sweep >= 360) {
      var a = polar(cx, cy, r, 0);
      var b = polar(cx, cy, r, 180);
      return 'M ' + a.x + ' ' + a.y + ' A ' + r + ' ' + r + ' 0 1 1 ' + b.x + ' ' + b.y + ' A ' + r + ' ' + r + ' 0 1 1 ' + a.x + ' ' + a.y;
    }
    var startPt = polar(cx, cy, r, start);
    var endPt = polar(cx, cy, r, end);
    var large = sweep > 180 ? 1 : 0;
    return 'M ' + startPt.x + ' ' + startPt.y + ' A ' + r + ' ' + r + ' 0 ' + large + ' 1 ' + endPt.x + ' ' + endPt.y;
  }

  function buildDonutSVG(count) {
    var visual = Math.max(0, Math.min(100, Number(count) || 0));
    var extra = Math.max(0, Math.min(100, (Number(count) || 0) - 100));
    var cx = 100;
    var cy = 100;
    var r = 78;
    var track = '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="none" stroke="#d48b8b" stroke-width="11"></circle>';
    var main = visual > 0
      ? '<path d="' + arcPath(cx, cy, r, 0, visual * 3.6) + '" fill="none" stroke="#FD1717" stroke-width="11" stroke-linecap="round"></path>'
      : '';
    var extraPath = extra > 0
      ? '<path d="' + arcPath(cx, cy, r, 0, extra * 3.6) + '" fill="none" stroke="#E60012" stroke-width="11" stroke-linecap="round"></path>'
      : '';
    return (
      '<svg class="imws-legal__donut-svg" viewBox="0 0 200 200" aria-hidden="true" focusable="false">' +
      track +
      main +
      extraPath +
      '<text x="100" y="94" text-anchor="middle" class="imws-legal__donut-count">' +
      escapeHtml(count) +
      '</text>' +
      '<text x="100" y="122" text-anchor="middle" class="imws-legal__donut-unit">contaminants</text>' +
      '</svg>'
    );
  }

  function barRow(label, value, max, modifier) {
    var pct = value == null || max <= 0 ? 0 : Math.max(0, Math.min(100, (value / max) * 100));
    return (
      '<div class="imws-bar' +
      (modifier ? ' imws-bar--' + modifier : '') +
      '">' +
      '<span>' +
      escapeHtml(label) +
      '</span>' +
      '<span class="imws-bar__track"><span class="imws-bar__fill" style="width:' +
      pct +
      '%"></span></span>' +
      '<span>' +
      escapeHtml(formatPpb(value)) +
      '</span>' +
      '</div>'
    );
  }

  function equalizeContaminantCards(root) {
    var cards = root.querySelectorAll('.imws-contaminant-card');
    if (!cards.length) return;
    var i;
    var max = 0;
    var open = [];
    for (i = 0; i < cards.length; i++) {
      cards[i].style.minHeight = '';
      var panel = cards[i].querySelector('.imws-contaminant-card__expanded, .imws-contaminant-card__details');
      open[i] = panel && !panel.hidden;
      if (panel) panel.hidden = true;
    }
    for (i = 0; i < cards.length; i++) {
      max = Math.max(max, cards[i].offsetHeight);
    }
    for (i = 0; i < cards.length; i++) {
      var panel2 = cards[i].querySelector('.imws-contaminant-card__expanded, .imws-contaminant-card__details');
      if (panel2 && open[i]) panel2.hidden = false;
      cards[i].style.minHeight = max + 'px';
    }
  }

  function bindContaminantCardResize(root) {
    if (root.getAttribute('data-imws-card-resize') === '1') return;
    root.setAttribute('data-imws-card-resize', '1');
    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        equalizeContaminantCards(root);
      }, 100);
    });
  }

  function loadHtml2Canvas(src) {
    if (window.html2canvas) return Promise.resolve(window.html2canvas);
    if (!src) return Promise.reject(new Error('missing html2canvas src'));
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = function () {
        if (window.html2canvas) resolve(window.html2canvas);
        else reject(new Error('html2canvas missing after load'));
      };
      script.onerror = function () {
        reject(new Error('html2canvas failed to load'));
      };
      document.head.appendChild(script);
    });
  }

  function focusables(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) {
      return !el.hasAttribute('hidden') && el.offsetParent !== null;
    });
  }

  function ImwsForm(root) {
    this.root = root;
    this.apiBase = (root.getAttribute('data-api-base') || '').replace(/\/+$/, '');
    this.html2canvasSrc = root.getAttribute('data-html2canvas-src') || '';
    this.showEmailCapture = root.getAttribute('data-show-email-capture') === 'true';
    this.emailRequired = root.getAttribute('data-email-required') === 'true';
    this.reportBg = root.getAttribute('data-report-bg') || '';
    this.lastLoadedZip = null;
    this.lastReport = null;
    this.modal = null;
    this.previousFocus = null;

    this.form = root.querySelector('form');
    this.zipInput = root.querySelector('.imws__zip-input') || root.querySelector('.imws__input');
    this.emailInput = root.querySelector('.imws__email-input');
    this.submitBtn = root.querySelector('.imws__submit');
    this.submitText = root.querySelector('.imws-hero__submit-text');
    this.submitSpinner = root.querySelector('.imws-hero__submit-spinner');
    this.submitTextDefault = this.submitText ? this.submitText.textContent : '';
    this.errorEl = root.querySelector('.imws__error');
    this.landingEl = root.querySelector('[id^="imws-landing"]');
    this.resultsEl = root.querySelector('[id^="imws-results"]');
    this.backBtn = root.querySelector('[id^="imws-back"]');
    this.announcer = root.querySelector('[data-imws-results-announcer]');
    this.utilityEl = root.querySelector('[data-imws-role="utility"]');
    this.legalEl = root.querySelector('[data-imws-role="legal"]');
    this.contaminantsEl = root.querySelector('[data-imws-role="contaminants"]');
    this.testedEl = root.querySelector('[data-imws-role="tested"]');

    if (this.reportBg) {
      root.style.setProperty('--imws-report-bg', 'url(' + JSON.stringify(this.reportBg) + ')');
    }

    this.bind();
    this.maybeAutoSubmit();
  }

  ImwsForm.prototype.bind = function () {
    var self = this;
    if (this.zipInput) {
      this.zipInput.addEventListener('input', function () {
        self.zipInput.value = self.zipInput.value.replace(/\D/g, '').slice(0, 5);
      });
    }
    if (this.form) {
      this.form.addEventListener('submit', function (event) {
        event.preventDefault();
        self.handleSubmit();
      });
    }
    if (this.backBtn) {
      this.backBtn.addEventListener('click', function () {
        self.reset();
      });
    }
  };

  ImwsForm.prototype.maybeAutoSubmit = function () {
    var params = new URLSearchParams(window.location.search);
    var zip = (params.get('zipcode') || '').trim();
    if (!/^\d{5}$/.test(zip) || !this.zipInput) return;
    this.zipInput.value = zip;
    this.handleSubmit();
  };

  ImwsForm.prototype.setLoading = function (on) {
    if (this.submitBtn) {
      this.submitBtn.disabled = on;
      this.submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
    }
    if (this.submitSpinner) this.submitSpinner.hidden = !on;
    if (this.submitText) this.submitText.textContent = on ? 'Analyzing...' : this.submitTextDefault;
  };

  ImwsForm.prototype.clearError = function () {
    if (this.errorEl) {
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }
    if (this.zipInput) this.zipInput.setAttribute('aria-invalid', 'false');
    if (this.emailInput) this.emailInput.setAttribute('aria-invalid', 'false');
  };

  ImwsForm.prototype.showError = function (message, field) {
    if (this.errorEl) {
      this.errorEl.hidden = false;
      this.errorEl.textContent = message;
    }
    if (field) {
      field.setAttribute('aria-invalid', 'true');
      field.focus();
    }
  };

  ImwsForm.prototype.validEmail = function (value) {
    return EMAIL_RE.test(String(value || '').trim());
  };

  ImwsForm.prototype.handleSubmit = function () {
    var self = this;
    this.clearError();
    var zip = this.zipInput ? this.zipInput.value.trim() : '';
    var email = this.emailInput ? this.emailInput.value.trim() : '';

    if (zip.length !== 5) {
      this.showError('Please enter a valid 5-digit zip code.', this.zipInput);
      return;
    }

    if (this.showEmailCapture) {
      if (this.emailRequired && !this.validEmail(email)) {
        this.showError('Please enter a valid email address.', this.emailInput);
        return;
      }
      if (email && !this.validEmail(email)) {
        this.showError('Please enter a valid email address.', this.emailInput);
        return;
      }
    }

    this.setLoading(true);

    this.lookup(zip, email)
      .catch(function (err) {
        self.showError(
          (err && err.message) || 'Unable to check water quality right now. Please try again later.'
        );
      })
      .finally(function () {
        self.setLoading(false);
      });
  };

  ImwsForm.prototype.fetchJson = function (url) {
    return fetch(url).then(function (res) {
      return res
        .json()
        .then(function (data) {
          return { ok: res.ok, data: data };
        })
        .catch(function () {
          return { ok: res.ok, data: null };
        });
    });
  };

  ImwsForm.prototype.lookup = function (zip, email) {
    var self = this;
    if (!this.apiBase) {
      return Promise.reject(new Error('Unable to check water quality right now. Please try again later.'));
    }

    var waterP = this.fetchJson(this.apiBase + '/water-data?zip=' + encodeURIComponent(zip));
    var utilityP = this.fetchJson(this.apiBase + '/utility-data?zip=' + encodeURIComponent(zip));
    var locP = fetch(this.apiBase + '/zip-location?zip=' + encodeURIComponent(zip))
      .then(function (res) {
        return res.json();
      })
      .catch(function () {
        return { city: '', state: '' };
      });

    return Promise.all([waterP, utilityP, locP]).then(function (parts) {
      var waterRes = parts[0];
      var utilityRes = parts[1];
      var locData = parts[2] || { city: '', state: '' };

      if (!waterRes.ok && !utilityRes.ok) {
        throw new Error('No data found for this zip code. Please try another.');
      }

      var waterData = waterRes.ok ? waterRes.data : null;
      var utilityData = utilityRes.ok ? utilityRes.data : null;
      if (waterData == null && utilityData == null) {
        throw new Error('No water quality data available for this zip code.');
      }

      var system = (utilityData && utilityData.SystemList && utilityData.SystemList[0]) || {};
      var utilityName = system.SystemName || 'Your Water Utility';
      var source = system.PrimSource_fulltext || 'Unknown Source';
      var populationRaw = system.Population == null ? '' : String(system.Population);
      var populationUi = populationRaw;
      if (populationRaw && Number.isFinite(Number(String(populationRaw).replace(/,/g, '')))) {
        populationUi = Number(String(populationRaw).replace(/,/g, '')).toLocaleString();
      }

      var city = locData.city || '';
      var state = locData.state || '';
      var location = city && state ? titleCase(city) + ', ' + state : city ? titleCase(city) : zip;

      var processed = processContaminants(waterData && waterData.ContaminantList);

      var afterEmail = Promise.resolve(true);
      if (email) {
        afterEmail = self.submitHeroEmail({
          email: email,
          zip: zip,
          contaminants: processed,
          source: source,
          utility: utilityName,
          location: location,
          serves: populationRaw
        });
      }

      return afterEmail.then(function (emailOk) {
        if (!emailOk && self.emailRequired) {
          throw new Error('Unable to send your report. Please try again.');
        }

        self.lastLoadedZip = zip;
        self.lastReport = {
          zip: zip,
          utilityName: utilityName,
          source: source,
          populationUi: populationUi,
          location: location,
          processed: processed
        };
        self.renderResults(self.lastReport);
        self.showResults();
        self.pushZip(zip);
      });
    });
  };

  ImwsForm.prototype.submitHeroEmail = function (payload) {
    var bodySubscribe = JSON.stringify({
      email: payload.email,
      zip: payload.zip,
      source: KLAVIYO_SOURCE
    });
    var bodyEmail = JSON.stringify({
      email: payload.email,
      zip: payload.zip,
      contaminants: payload.contaminants,
      source: payload.source,
      utility: payload.utility,
      location: payload.location,
      serves: payload.serves
    });
    var headers = { 'Content-Type': 'application/json' };

    return Promise.all([
      fetch(this.apiBase + '/klaviyo', { method: 'POST', headers: headers, body: bodySubscribe }),
      fetch(this.apiBase + '/klaviyo/email', { method: 'POST', headers: headers, body: bodyEmail })
    ])
      .then(function (responses) {
        return responses[0].ok && responses[1].ok;
      })
      .catch(function () {
        return false;
      });
  };

  ImwsForm.prototype.submitLegalEmail = function (payload) {
    var self = this;
    var headers = { 'Content-Type': 'application/json' };
    return fetch(this.apiBase + '/klaviyo', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        email: payload.email,
        zip: payload.zip,
        source: KLAVIYO_SOURCE
      })
    })
      .then(function (subscribeRes) {
        if (!subscribeRes.ok) return { subscribeOk: false, emailOk: false };
        return fetch(self.apiBase + '/klaviyo/email', {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({
            email: payload.email,
            zip: payload.zip,
            contaminants: payload.contaminants,
            source: payload.source,
            utility: payload.utility,
            location: payload.location,
            serves: payload.serves
          })
        }).then(function (emailRes) {
          return { subscribeOk: true, emailOk: emailRes.ok };
        });
      })
      .catch(function () {
        return Promise.reject(new Error('network'));
      });
  };

  ImwsForm.prototype.renderResults = function (report) {
    this.renderUtility(report);
    this.renderLegal(report);
    this.renderContaminants(report);
    this.renderTested(report);
  };

  ImwsForm.prototype.renderUtility = function (report) {
    if (!this.utilityEl) return;
    var el = this.utilityEl;
    var ewgLogo = attr(el, 'ewg-logo');
    var html =
      '<div class="imws-utility__card">' +
      (attr(el, 'eyebrow') ? '<p class="imws-utility__eyebrow">' + escapeHtml(attr(el, 'eyebrow')) + '</p>' : '') +
      '<h2 class="imws-utility__name">' +
      escapeHtml(report.utilityName) +
      '</h2>' +
      '<div class="imws-utility__stats">' +
      this.stat(attr(el, 'label-location') || 'Location', report.location) +
      this.stat(attr(el, 'label-serves') || 'Serves', report.populationUi || '—') +
      this.stat(attr(el, 'label-source') || 'Source', report.source) +
      this.stat(attr(el, 'label-data') || 'Data', attr(el, 'range') || '2021–2023') +
      '</div>' +
      '<div class="imws-utility__ewg">' +
      (ewgLogo ? '<img src="' + escapeHtml(ewgLogo) + '" alt="">' : '') +
      '<span>' +
      escapeHtml(attr(el, 'ewg-text') || 'Powered by EWG Tap Water Database') +
      '</span>' +
      '</div>' +
      '<p class="imws-utility__note">' +
      escapeHtml(attr(el, 'ewg-note')) +
      '</p>' +
      '</div>';
    el.innerHTML = html;
  };

  ImwsForm.prototype.stat = function (label, value) {
    return (
      '<div class="imws-utility__stat"><span class="imws-utility__stat-label">' +
      escapeHtml(label) +
      '</span><span class="imws-utility__stat-value">' +
      escapeHtml(value) +
      '</span></div>'
    );
  };

  ImwsForm.prototype.renderLegal = function (report) {
    if (!this.legalEl) return;
    var el = this.legalEl;
    var count = report.processed.length;
    var shareUrl = encodeURIComponent(window.location.href);
    var showEmail = attr(el, 'show-email-capture') === 'true';
    var overLimit = attr(el, 'over-limit-text') || 'Reported Over Acceptable Health Limit';
    var overHtml = escapeHtml(overLimit).replace(' Acceptable Health Limit', '<br> Acceptable Health Limit');
    var sharePrompt =
      attr(el, 'share-prompt') ||
      attr(el, 'download-text') ||
      'Download your Contaminant Report to share on social media:';
    var html =
      '<div class="imws-legal__donut-wrap">' +
      buildDonutSVG(count) +
      '<p class="imws-legal__over-limit">' +
      overHtml +
      '</p>' +
      '<div class="imws-legal__share-block">' +
      '<button type="button" class="imws-legal__download" data-imws-download data-imws-open-report>' +
      DOWNLOAD_ICON +
      '<span>' +
      escapeHtml(sharePrompt) +
      '</span>' +
      '</button>' +
      '<div class="imws-legal__social">' +
      this.shareLink('facebook', 'https://www.facebook.com/sharer/sharer.php?u=' + shareUrl, 'Share on Facebook', 'Facebook') +
      this.shareLink('x', 'https://twitter.com/intent/tweet?url=' + shareUrl + '&text=Check+out+my+water+report', 'Share on X', 'X') +
      this.shareLink('reddit', 'https://www.reddit.com/submit?url=' + shareUrl + '&title=Check+out+my+water+report', 'Share on Reddit', 'Reddit') +
      this.shareLink('instagram', 'https://www.instagram.com', 'Share on Instagram', 'Instagram') +
      this.shareLink('whatsapp', 'https://api.whatsapp.com/send?text=Check+out+my+water+report:+' + shareUrl, 'Share on WhatsApp', 'WhatsApp') +
      this.shareLink('email', 'mailto:?subject=Check%20out%20my%20water%20report&body=' + shareUrl, 'Share via Email', 'Email') +
      '</div>' +
      '</div>' +
      '</div>' +
      '<div class="imws-legal__copy">' +
      '<h3>' +
      escapeHtml(attr(el, 'title') || 'Legal does not necessarily equal safe.') +
      '</h3>' +
      '<ul>' +
      [attr(el, 'bullet-1'), attr(el, 'bullet-2'), attr(el, 'bullet-3')]
        .filter(Boolean)
        .map(function (item) {
          return '<li>' + escapeHtml(item) + '</li>';
        })
        .join('') +
      '</ul>' +
      (showEmail ? this.legalEmailMarkup(el) : '') +
      '</div>';
    el.innerHTML = html;
    this.bindLegal(el);
  };

  ImwsForm.prototype.shareLink = function (name, href, label, alt) {
    var external = href.indexOf('mailto:') !== 0;
    return (
      '<a href="' +
      escapeHtml(href) +
      '"' +
      (external ? ' target="_blank" rel="noopener noreferrer" aria-describedby="a11y-new-window-message"' : '') +
      ' aria-label="' +
      escapeHtml(label) +
      '"><img src="' +
      escapeHtml(SHARE_ICONS[name]) +
      '" alt="' +
      escapeHtml(alt || label) +
      '" loading="lazy"></a>'
    );
  };

  ImwsForm.prototype.legalEmailMarkup = function (el) {
    return (
      '<form class="imws-legal__email" data-imws-legal-email novalidate>' +
      '<label class="sr-only" for="imws-legal-email">' +
      escapeHtml(attr(el, 'email-label') || 'Email') +
      '</label>' +
      '<input class="imws__input" id="imws-legal-email" type="email" autocomplete="email" placeholder="' +
      escapeHtml(attr(el, 'email-placeholder') || 'Enter your email') +
      '">' +
      '<p class="imws-legal__email-error" id="imws-email-error" hidden>Unable to send your report. Please try again.</p>' +
      '<button type="submit" class="imws-legal__email-submit" data-imws-legal-email-submit>' +
      escapeHtml(attr(el, 'email-button') || 'Send my report') +
      '</button>' +
      '</form>'
    );
  };

  ImwsForm.prototype.bindLegal = function (el) {
    var self = this;
    var downloadBtn = el.querySelector('[data-imws-download], [data-imws-open-report]');
    if (downloadBtn) {
      downloadBtn.addEventListener('click', function () {
        self.openReportModal(downloadBtn);
      });
    }
    var form = el.querySelector('[data-imws-legal-email]');
    if (!form) return;
    var input = form.querySelector('input');
    var error = form.querySelector('.imws-legal__email-error');
    var button = form.querySelector('[data-imws-legal-email-submit]');
    var original = button ? button.textContent : '';
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = input ? input.value.trim() : '';
      var zip = self.lastLoadedZip;
      if (!self.validEmail(email) || !zip) {
        if (error) error.hidden = false;
        if (input) {
          input.setAttribute('aria-invalid', 'true');
          input.focus();
        }
        return;
      }
      if (error) error.hidden = true;
      if (input) input.setAttribute('aria-invalid', 'false');
      if (button) button.disabled = true;
      var report = self.lastReport || {};
      self
        .submitLegalEmail({
          email: email,
          zip: zip,
          contaminants: report.processed || [],
          source: report.source,
          utility: report.utilityName,
          location: report.location,
          serves: ''
        })
        .then(function (result) {
          if (!result.subscribeOk) {
            if (error) {
              error.hidden = false;
              error.textContent = 'Unable to send your report. Please try again.';
            }
            if (button) {
              button.disabled = false;
              button.textContent = original;
            }
            return;
          }
          if (result.emailOk) {
            if (button) button.textContent = attr(el, 'email-sent-text') || 'Report Sent!';
            if (input) input.disabled = true;
            return;
          }
          if (button) {
            button.disabled = false;
            button.textContent = original;
          }
        })
        .catch(function () {
          if (button) {
            button.disabled = false;
            button.textContent = original;
          }
        });
    });
  };

  ImwsForm.prototype.renderContaminants = function (report) {
    if (!this.contaminantsEl) return;
    var el = this.contaminantsEl;
    var heading = attr(el, 'heading');
    var emptyText = attr(el, 'empty-text') || 'No contaminants were reported over EWG health guidelines for this zip code.';
    var expandLabel = attr(el, 'expand-label') || 'Show details';
    var collapseLabel = attr(el, 'collapse-label') || 'Hide details';
    var html = heading ? '<h2 class="imws-contaminants__heading">' + escapeHtml(heading) + '</h2>' : '';
    if (!report.processed.length) {
      html += '<p class="imws-contaminants__empty">' + escapeHtml(emptyText) + '</p>';
      el.innerHTML = html;
      this.placeNextStep(el);
      return;
    }
    html +=
      '<div class="imws-contaminants__scroller">' +
      report.processed
        .map(function (item, index) {
          return (
            '<article class="imws-contaminant-card">' +
            '<div class="imws-contaminant-card__top">' +
            '<h3 class="imws-contaminant-card__name">' +
            escapeHtml(item.name) +
            '</h3>' +
            '<button type="button" class="imws-contaminant-card__toggle" aria-expanded="false" aria-label="' +
            escapeHtml(expandLabel) +
            '" data-imws-card-toggle="' +
            index +
            '">+</button>' +
            '</div>' +
            '<p class="imws-contaminant-card__effect">' +
            '<span class="imws-contaminant-card__effect-label">Potential Effect: </span>' +
            '<strong>' +
            escapeHtml(titleCase(item.effect)) +
            '</strong>' +
            '</p>' +
            '<p class="imws-contaminant-card__ratio">' +
            escapeHtml(item.ratio) +
            'x</p>' +
            '<p class="imws-contaminant-card__above">Above EWG health guidelines</p>' +
            '<div class="imws-contaminant-card__details" hidden data-imws-card-details="' +
            index +
            '">' +
            '<p class="imws-contaminant-card__desc">' +
            escapeHtml(item.description) +
            '</p>' +
            barRow(attr(el, 'bar-guideline') || 'EWG guideline', item.guideline, item.maxBarValue) +
            barRow(attr(el, 'bar-national') || 'National average', item.nationalAvg, item.maxBarValue) +
            barRow(attr(el, 'bar-state') || 'State average', item.stateAvg, item.maxBarValue) +
            barRow(attr(el, 'bar-home') || 'Your water', item.utility, item.maxBarValue, 'home') +
            barRow(attr(el, 'bar-legal') || 'Legal limit', item.legal, item.maxBarValue, 'legal') +
            '<div class="imws-contaminant-card__note">' +
            'The state and national averages were calculated using the averages of the contaminant measurements for each utility in ' +
            escapeHtml(item.timeline && String(item.timeline).trim() ? String(item.timeline).trim() : 'the reported period') +
            '.<br>ppb = parts per billion' +
            '</div>' +
            '</div>' +
            '</article>'
          );
        })
        .join('') +
      '</div>';
    el.innerHTML = html;
    this.placeNextStep(el);
    el.querySelectorAll('[data-imws-card-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.getAttribute('data-imws-card-toggle');
        var details = el.querySelector('[data-imws-card-details="' + index + '"]');
        var open = details && !details.hidden;
        if (details) details.hidden = open;
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        btn.textContent = open ? '+' : '\u2212';
        btn.setAttribute('aria-label', open ? expandLabel : collapseLabel);
      });
    });
    bindContaminantCardResize(el);
    requestAnimationFrame(function () {
      equalizeContaminantCards(el);
    });
  };

  ImwsForm.prototype.placeNextStep = function (contaminantsEl) {
    var template = this.root.querySelector('template[data-imws-next-template]');
    if (!template || !contaminantsEl) return;
    var existing = contaminantsEl.querySelector('.imws-next');
    if (existing) existing.remove();
    var card = template.content.querySelector('.imws-next');
    if (!card) return;
    card = card.cloneNode(true);
    var heading = contaminantsEl.querySelector('.imws-contaminants__heading');
    if (heading && heading.parentNode) {
      heading.parentNode.insertBefore(card, heading);
    } else {
      contaminantsEl.insertBefore(card, contaminantsEl.firstChild);
    }
  };

  ImwsForm.prototype.renderTested = function (report) {
    if (!this.testedEl) return;
    var el = this.testedEl;
    var name = report.utilityName;
    function withName(value, fallback) {
      return String(value || fallback || '').replace(/\{name\}/g, name);
    }
    var heading = attr(el, 'detected-heading') || 'Other Contaminants Tested';
    var intro =
      attr(el, 'detected-intro') ||
      "Contaminants detected between 2012 and 2014 and were not part of EPA's UCMR-3 testing program or radiologicals:";
    var notDetectedHeading =
      attr(el, 'not-detected-heading') || 'Chemicals tested for but not detected from 2012 to 2017:';
    var complianceHeading = withName(
      attr(el, 'compliance-heading'),
      '{name} compliance with legally mandated federal standards:'
    );
    var compliance = withName(
      attr(el, 'compliance'),
      'From April 2018 to March 2019, {name} complied with health-based drinking water standards.'
    );
    var disclaimer =
      attr(el, 'disclaimer') ||
      'Includes chemicals detected in 2015–2017 for which annual utility averages exceeded the federal Maximum Contaminant Level (MCL); chemicals detected in 2015–2017 for which annual utility averages exceeded an EWG-selected health guideline established by a federal or state public health authority; chemicals detected under the EPA’s Unregulated Contaminant Monitoring Rule (UCMR 3) program in 2013 to 2015 (and subsequent testing when available), for which annual utility averages exceeded a health guideline established by a federal or state public health authority; radiological contaminants detected between 2012 and 2017.';
    var footnote =
      attr(el, 'footnote') ||
      '† HAA5 is a contaminant group that includes monochloroacetic acid, dichloroacetic acid, trichloroacetic acid, monobromoacetic acid and dibromoacetic acid. TTHM is a contaminant group that includes bromodichloromethane, bromoform, chloroform and dibromochloromethane.';
    el.innerHTML =
      '<div class="imws-tested__inner">' +
      '<div class="imws-tested__notes">' +
      (disclaimer ? '<p class="imws-tested__disclaimer">' + escapeHtml(disclaimer) + '</p>' : '') +
      (footnote ? '<p class="imws-tested__footnote">' + escapeHtml(footnote) + '</p>' : '') +
      '</div>' +
      '<h2 class="imws-tested__heading">' +
      escapeHtml(heading) +
      '</h2>' +
      '<p class="imws-tested__intro">' +
      escapeHtml(intro) +
      '</p>' +
      '<ul class="imws-tested__list">' +
      DETECTED_CONTAMINANTS.map(function (item) {
        return '<li>' + escapeHtml(item) + '</li>';
      }).join('') +
      '</ul>' +
      '<h3 class="imws-tested__subheading">' +
      escapeHtml(notDetectedHeading) +
      '</h3>' +
      '<ul class="imws-tested__list">' +
      NOT_DETECTED.map(function (item) {
        return '<li>' + escapeHtml(item) + '</li>';
      }).join('') +
      '</ul>' +
      '<h3 class="imws-tested__compliance-heading">' +
      escapeHtml(complianceHeading) +
      '</h3>' +
      '<p class="imws-tested__compliance">' +
      escapeHtml(compliance) +
      '</p>' +
      '</div>';
  };

  ImwsForm.prototype.showResults = function () {
    if (this.landingEl) this.landingEl.hidden = true;
    if (this.resultsEl) this.resultsEl.hidden = false;
    this.toggleLandingSections(false);
    if (this.announcer) {
      this.announcer.textContent = 'Water quality report loaded.';
    }
  };

  ImwsForm.prototype.reset = function () {
    if (this.resultsEl) this.resultsEl.hidden = true;
    if (this.landingEl) this.landingEl.hidden = false;
    this.toggleLandingSections(true);
    [this.utilityEl, this.legalEl, this.contaminantsEl, this.testedEl].forEach(function (el) {
      if (el) el.innerHTML = '';
    });
    if (this.zipInput) this.zipInput.value = '';
    if (this.emailInput) this.emailInput.value = '';
    this.lastLoadedZip = null;
    this.lastReport = null;
    this.clearError();
    this.closeModal();
    this.replaceZip();
    if (this.zipInput) this.zipInput.focus();
  };

  ImwsForm.prototype.toggleLandingSections = function (visible) {
    var seen = [];
    function hide(node) {
      if (!node || seen.indexOf(node) !== -1) return;
      seen.push(node);
      node.hidden = !visible;
    }

    document.querySelectorAll('.imws-tap, .imws-faq, .section-imws-hidden-danger, .section-imws-safe-to-drink').forEach(hide);

    [
      'imws_tap_water',
      'imws_hidden_danger',
      'custom_section_76tGdq',
      'custom_section_RLXyA7',
      'custom_section_GMQVz7',
      'custom_section_3qfBcQ',
      'imws_safe_to_drink',
      'custom_section_GWm8bB',
      'faq_mh9pGJ'
    ].forEach(function (key) {
      hide(document.getElementById('shopify-section-' + key));
      document.querySelectorAll('[id$="__' + key + '"]').forEach(hide);
    });

    var raw = this.root.getAttribute('data-hide-on-results') || '';
    raw.split(/[\n,]+/).forEach(function (line) {
      var selector = line.trim();
      if (!selector) return;
      try {
        document.querySelectorAll(selector).forEach(hide);
      } catch (err) {
        /* invalid selector */
      }
      var key = selector.replace(/^#shopify-section-/, '').replace(/^#/, '');
      if (/^[A-Za-z0-9_-]+$/.test(key)) {
        document.querySelectorAll('[id$="__' + key + '"]').forEach(hide);
        hide(document.getElementById('shopify-section-' + key));
      }
    });
  };

  ImwsForm.prototype.pushZip = function (zip) {
    var url = new URL(window.location.href);
    url.searchParams.set('zipcode', zip);
    window.history.pushState({}, '', url);
  };

  ImwsForm.prototype.replaceZip = function () {
    var url = new URL(window.location.href);
    url.searchParams.delete('zipcode');
    window.history.replaceState({}, '', url);
  };

  ImwsForm.prototype.ensureModal = function () {
    if (this.modal) return this.modal;
    var modal = document.createElement('div');
    modal.className = 'imws-modal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="imws-modal__overlay" data-imws-modal-overlay></div>' +
      '<div class="imws-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="imws-modal-title" tabindex="-1">' +
      '<button type="button" class="imws-modal__close" data-imws-modal-close aria-label="Close">&times;</button>' +
      '<h2 class="imws-modal__title" id="imws-modal-title">Shareable report</h2>' +
      '<img class="imws-modal__preview" alt="Contaminant report preview">' +
      '<button type="button" class="imws-modal__download" data-imws-modal-download>Download PNG</button>' +
      '</div>';
    document.body.appendChild(modal);
    this.modal = modal;
    this.bindModal(modal);
    return modal;
  };

  ImwsForm.prototype.syncModalContrast = function (dialog) {
    var ink = contrastingInk(window.getComputedStyle(dialog).backgroundColor);
    dialog.style.setProperty('--imws-modal-fg', ink);
    dialog.style.color = ink;
  };

  ImwsForm.prototype.bindModal = function (modal) {
    var self = this;
    modal.querySelector('[data-imws-modal-overlay]').addEventListener('click', function () {
      self.closeModal();
    });
    modal.querySelector('[data-imws-modal-close]').addEventListener('click', function () {
      self.closeModal();
    });
    modal.querySelector('[data-imws-modal-download]').addEventListener('click', function () {
      if (!self.reportDataUrl) return;
      var link = document.createElement('a');
      link.href = self.reportDataUrl;
      link.download = 'Contaminant_Report.png';
      link.click();
    });
    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        self.closeModal();
        return;
      }
      if (event.key !== 'Tab') return;
      var nodes = focusables(modal);
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  ImwsForm.prototype.buildShareCard = function () {
    var report = this.lastReport || {};
    var card = document.createElement('div');
    card.className = 'imws-share-card';
    if (this.reportBg) card.style.setProperty('--imws-report-bg', 'url(' + JSON.stringify(this.reportBg) + ')');
    card.style.width = '720px';
    card.style.color = '#ffffff';
    card.innerHTML =
      '<h2 class="imws-utility__name" style="color:#ffffff">' +
      escapeHtml(report.utilityName || 'Your Water Utility') +
      '</h2>' +
      '<p class="imws-share-card__meta" style="color:#ffffff">' +
      escapeHtml(report.location || '') +
      '</p>' +
      '<p class="imws-share-card__meta" style="color:#ffffff"><strong>' +
      escapeHtml((report.processed && report.processed.length) || 0) +
      '</strong> contaminants reported over the EWG health guideline</p>';
    return card;
  };

  ImwsForm.prototype.openReportModal = function (trigger) {
    var self = this;
    var original = trigger.innerHTML;
    loadHtml2Canvas(this.html2canvasSrc)
      .then(function (html2canvas) {
        var card = self.buildShareCard();
        card.style.position = 'fixed';
        card.style.left = '-10000px';
        card.style.top = '0';
        document.body.appendChild(card);
        return html2canvas(card, { scale: 2, useCORS: true, backgroundColor: null }).then(function (canvas) {
          document.body.removeChild(card);
          return canvas;
        });
      })
      .then(function (canvas) {
        self.reportDataUrl = canvas.toDataURL('image/png');
        var modal = self.ensureModal();
        var preview = modal.querySelector('.imws-modal__preview');
        preview.src = self.reportDataUrl;
        self.previousFocus = trigger;
        modal.hidden = false;
        var dialog = modal.querySelector('.imws-modal__dialog');
        if (dialog) {
          self.syncModalContrast(dialog);
          dialog.focus();
        }
        trigger.innerHTML = original;
      })
      .catch(function () {
        trigger.innerHTML = original;
      });
  };

  ImwsForm.prototype.closeModal = function () {
    if (!this.modal || this.modal.hidden) return;
    this.modal.hidden = true;
    if (this.previousFocus) this.previousFocus.focus();
  };

  document.querySelectorAll('.imws').forEach(function (root) {
    if (root.getAttribute('data-imws-bound')) return;
    root.setAttribute('data-imws-bound', 'true');
    new ImwsForm(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["imws-tap-water"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ImwsTapDefined) return;
  window.__ImwsTapDefined = true;

  var INTERVAL_MS = 5000;
  var FALLBACK_CITIES = [
    { name: 'LOS ANGELES', count: 24, provider: 'Water and Power', caption: '' },
    { name: 'MIAMI', count: 41, provider: 'Dade Water and Sewer Authority', caption: '' },
    { name: 'NEW YORK', count: 22, provider: 'City System', caption: '' },
    { name: 'CHICAGO', count: 13, provider: 'City', caption: 'City of Chicago' }
  ];

  function titleCase(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/\b\w/g, function (ch) { return ch.toUpperCase(); });
  }

  function captionFor(city) {
    var count = Number(city.count) || 0;
    var custom = String(city.caption || '').trim();
    var place = custom;
    if (!place) {
      var parts = [];
      if (city.name) parts.push(titleCase(city.name));
      if (city.provider) parts.push(city.provider);
      place = parts.join(' ');
    }
    return count + ' contaminants detected in ' + place;
  }

  function polar(cx, cy, r, angle) {
    var rad = ((angle - 90) * Math.PI) / 180;
    return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
  }

  function arcPath(cx, cy, r, start, end) {
    var sweep = end - start;
    if (sweep <= 0) return '';
    if (sweep >= 360) {
      var a = polar(cx, cy, r, 0);
      var b = polar(cx, cy, r, 180);
      return 'M ' + a.x + ' ' + a.y + ' A ' + r + ' ' + r + ' 0 1 1 ' + b.x + ' ' + b.y + ' A ' + r + ' ' + r + ' 0 1 1 ' + a.x + ' ' + a.y;
    }
    var startPt = polar(cx, cy, r, start);
    var endPt = polar(cx, cy, r, end);
    var large = sweep > 180 ? 1 : 0;
    return 'M ' + startPt.x + ' ' + startPt.y + ' A ' + r + ' ' + r + ' 0 ' + large + ' 1 ' + endPt.x + ' ' + endPt.y;
  }

  function renderDonut(donutEl, count) {
    if (!donutEl) return;
    var visual = Math.max(0, Math.min(100, Number(count) || 0));
    var extra = Math.max(0, (Number(count) || 0) - 100);
    extra = Math.min(100, extra);
    var cx = 100;
    var cy = 100;
    var r = 84;
    var track = '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="none" stroke="#d48b8b" stroke-width="8"></circle>';
    var main = visual > 0
      ? '<path d="' + arcPath(cx, cy, r, 0, visual * 3.6) + '" fill="none" stroke="#FD1717" stroke-width="8" stroke-linecap="round"></path>'
      : '';
    var extraPath = extra > 0
      ? '<path d="' + arcPath(cx, cy, r, 0, extra * 3.6) + '" fill="none" stroke="#E60012" stroke-width="8" stroke-linecap="round"></path>'
      : '';
    donutEl.innerHTML =
      '<svg class="imws-tap__donut-svg" viewBox="0 0 200 200" aria-hidden="true" focusable="false">' +
      track + main + extraPath +
      '<text x="100" y="94" text-anchor="middle" class="imws-tap__donut-count">' + (Number(count) || 0) + '</text>' +
      '<text x="100" y="122" text-anchor="middle" class="imws-tap__donut-unit">contaminants</text>' +
      '</svg>';
  }

  function parseCities(root) {
    var jsonEl = root.querySelector('[data-imws-tap-cities]');
    var cities = [];
    try {
      cities = JSON.parse(jsonEl.textContent);
    } catch (err) {
      cities = [];
    }
    return cities.length ? cities : FALLBACK_CITIES.slice();
  }

  function init(root) {
    if (!root || root.getAttribute('data-imws-tap-ready') === 'true') return;
    root.setAttribute('data-imws-tap-ready', 'true');

    var cities = parseCities(root);
    var donutEl = root.querySelector('[data-imws-tap-donut]');
    var captionEl = root.querySelector('[data-imws-tap-caption]');
    var timeline = root.querySelector('[data-imws-tap-timeline]');
    var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var activeIndex = 0;
    var rotateTimer = null;
    var userStopped = false;
    var holdPaused = false;

    function reduceMotion() {
      return motionQuery.matches;
    }

    function setActive(index, options) {
      if (index < 0 || index >= cities.length) return;
      activeIndex = index;
      var city = cities[index];
      var fromRotate = options && options.fromRotate;
      renderDonut(donutEl, city.count);
      if (captionEl) captionEl.textContent = captionFor(city);

      if (timeline) {
        timeline.querySelectorAll('[data-imws-tap-index]').forEach(function (item, i) {
          var on = i === index;
          item.classList.toggle('is-active', on);
          item.setAttribute('aria-checked', on ? 'true' : 'false');
          if (!fromRotate) item.tabIndex = on ? 0 : -1;
        });
      }

      if (options && options.focus && timeline) {
        var current = timeline.querySelector('[data-imws-tap-index="' + index + '"]');
        if (current) current.focus();
      }
    }

    function next() {
      setActive((activeIndex + 1) % cities.length, { fromRotate: true });
    }

    function stopRotate() {
      if (rotateTimer) {
        window.clearInterval(rotateTimer);
        rotateTimer = null;
      }
    }

    function startRotate() {
      stopRotate();
      if (reduceMotion() || userStopped || holdPaused || cities.length < 2) return;
      rotateTimer = window.setInterval(next, INTERVAL_MS);
    }

    function stopForUser() {
      userStopped = true;
      stopRotate();
    }

    function onHoldStart() {
      holdPaused = true;
      stopRotate();
    }

    function onHoldEnd(event) {
      if (event.type === 'focusout' && event.relatedTarget && root.contains(event.relatedTarget)) return;
      holdPaused = false;
      startRotate();
    }

    function onTimelineClick(event) {
      var item = event.target.closest('[data-imws-tap-index]');
      if (!item || !timeline.contains(item)) return;
      setActive(Number(item.getAttribute('data-imws-tap-index')));
      stopForUser();
    }

    function onTimelineKeydown(event) {
      var item = event.target.closest('[data-imws-tap-index]');
      if (!item || !timeline.contains(item)) return;
      var index = Number(item.getAttribute('data-imws-tap-index'));
      var nextIndex = index;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % cities.length;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + cities.length) % cities.length;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = cities.length - 1;
      else if (event.key !== ' ' && event.key !== 'Enter') return;
      event.preventDefault();
      setActive(nextIndex, { focus: true });
      stopForUser();
    }

    function onMotionChange() {
      if (reduceMotion()) stopRotate();
      else startRotate();
    }

    if (timeline) {
      timeline.addEventListener('click', onTimelineClick);
      timeline.addEventListener('keydown', onTimelineKeydown);
    }
    root.addEventListener('mouseenter', onHoldStart);
    root.addEventListener('mouseleave', onHoldEnd);
    root.addEventListener('focusin', onHoldStart);
    root.addEventListener('focusout', onHoldEnd);
    if (motionQuery.addEventListener) motionQuery.addEventListener('change', onMotionChange);
    else if (motionQuery.addListener) motionQuery.addListener(onMotionChange);

    setActive(0);
    startRotate();

    root._imwsTapCleanup = function () {
      stopRotate();
      if (timeline) {
        timeline.removeEventListener('click', onTimelineClick);
        timeline.removeEventListener('keydown', onTimelineKeydown);
      }
      root.removeEventListener('mouseenter', onHoldStart);
      root.removeEventListener('mouseleave', onHoldEnd);
      root.removeEventListener('focusin', onHoldStart);
      root.removeEventListener('focusout', onHoldEnd);
      if (motionQuery.removeEventListener) motionQuery.removeEventListener('change', onMotionChange);
      else if (motionQuery.removeListener) motionQuery.removeListener(onMotionChange);
      root.removeAttribute('data-imws-tap-ready');
      root._imwsTapCleanup = null;
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.imws-tap-root').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('.imws-tap-root').forEach(function (root) {
      if (typeof root._imwsTapCleanup === 'function') root._imwsTapCleanup();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
